import React, { Component } from 'react'
import {Container, Image, Card, Transition, Segment, Icon, Tab, Grid, Label} from 'semantic-ui-react'
import {portraitImageUrl, roleImageUrl, roleAlternateImageUrl, factionImageUrl, colorForRole, isObjectEmpty, coreImageUrl, specialImageUrl, talentImageUrl} from '../utility/Global'
import guardianIds from '../assets/json/guardians.json'
import { getGuardian } from '../utility/Firebase'

const cachedGuardians = {}

const GuardianFactionIcon = ({faction, size = 'mini'}) => (
  <Image className={`guardian-card-icon ${size}`} src={factionImageUrl(faction)} />
)

const GuardianRoleIcon = ({role, size = 'xxx-small'}) => (
  <Image className={`guardian-card-icon ${size}`} src={roleImageUrl(role)}/> //bcg-${colorForRole(role)}
)

const GuardianAlternateRoleIcon = ({role, size = 'xxx-small'}) => (
  <Image className={`guardian-card-icon ${size}`} src={roleAlternateImageUrl(role)}/>
)

const GuardianCard = ({guardian, size, onClick}) => (
  <Card className='guardian-card' onClick={onClick}>
    <Card.Content className='guardian-card-header-content'>
      <GuardianFactionIcon faction={guardian?.faction}/>
    </Card.Content>
    <Image className={`guardian-card-image bcg-${colorForRole(guardian?.role)}-secondary`} src={portraitImageUrl(guardian?.name, size)} wrapped ui={false} />
    <Card.Content className={`guardian-card-content bcg-${colorForRole(guardian?.role)}`}>
      <Card.Header className='guardian-card-header'>
          {guardian?.name}
        </Card.Header>
      <Card.Meta className='guardian-card-meta'>
          <GuardianRoleIcon role={guardian?.role} />
      </Card.Meta>
    </Card.Content>
  </Card>
)

const GuardianDetailsPage = ({landscapeView, guardian, onHandleBack, onHandlePrevious, onHandleNext}) => (
  <Segment basic>
    {/* <Icon className='guardian-details-back-button' inverted size='big' name='arrow left' onClick={onHandleBack} /> */}
    <Image className='guardian-details-portrait' size='huge' src={portraitImageUrl(guardian?.name, landscapeView ? 'large' : 'small')} />
    {landscapeView ? (
      <>
        <GuardianDetailsLeftPanel guardian={guardian} />
        <GuardianDetailsRightPanel guardian={guardian} />
      </>
    ) : <GuardianTabbedView guardian={guardian} /> }
    <DirectionPanel role={guardian?.role} faction={guardian?.faction} onHandleBack={onHandleBack} onHandlePrevious={onHandlePrevious} onHandleNext={onHandleNext} />
  </Segment>
)

const GuardianTabbedView = ({guardian}) => (
  <Tab renderActiveOnly={false} 
  menu={{attached: false, fluid : true, widths: '3', className: `bcg-${colorForRole(guardian?.role)}-secondary`}} 
  className='guardian-details-tabbed-panel'
   panes={[
    { menuItem: 'Bio', pane: <Tab.Pane key='0' className='transparent no-border'><GuardianBioCard guardian={guardian} /></Tab.Pane> },
    { menuItem: 'Abilities', pane: <Tab.Pane key='1' className='transparent no-border'><GuardianAbilityCards guardian={guardian} /></Tab.Pane> },
    { menuItem: 'Talents', pane: <Tab.Pane key='2' className='transparent no-border'><GuardianTalentsContainer guardian={guardian} /></Tab.Pane> }
  ]} />
)

const GuardianBioCard = ({guardian}) => (
  <Card fluid className={`guardian-bio-container bcg-${colorForRole(guardian?.role)}-secondary`}>
    <Card.Content>
      <Card.Header className={`bcg-${colorForRole(guardian?.role)}-label`}>{guardian?.name}</Card.Header>
      <Card.Description>
        {guardian?.bio}
      </Card.Description>
    </Card.Content>
  </Card>
)

const GuardianAbilityCards = ({guardian}) => (
  <Card.Group className='guardian-abilities-container'>
        <AbilityCard type='Core' src={coreImageUrl(guardian?.name)} ability={guardian?.core} color={`bcg-${colorForRole(guardian?.role)}-secondary`} />
        <AbilityCard type='Special' src={specialImageUrl(guardian?.name)} ability={guardian?.special} color={`bcg-${colorForRole(guardian?.role)}-secondary`} />
  </Card.Group>
)

const GuardianDetailsLeftPanel = ({guardian}) => (
  <Segment className='guardian-details-left-panel transparent no-border'>
    <GuardianBioCard guardian={guardian} />

    <GuardianAbilityCards guardian={guardian} />
  </Segment>
)

const GuardianDetailsRightPanel = ({guardian}) => (
  <Segment className='guardian-details-right-panel transparent no-border'>
    <GuardianTalentsContainer guardian={guardian} />
  </Segment>
)

const GuardianTalentsContainer = ({guardian}) => (
  <Card.Group className={`guardian-talents-container`}>
  {
    guardian?.talents.map((talent, index) => 
      <TalentCard key={index} index={index+1} id={guardian?.name} color={`bcg-${colorForRole(guardian?.role)}-secondary`} talent={talent} />
    )
  }
  </Card.Group>
)

const TalentCard = ({index, id, talent, color}) => (
  <Card fluid className={`guardian-talent-card ${color}`}>
    <Card.Content>
      <div className='guardian-talent-icon-container'>
        <Image
          floated='left'
          size='mini'
          src={talentImageUrl(index, id)}
        />
      </div>
      <Card.Header>{talent?.name}</Card.Header>
      <Card.Description>
        {talent?.text}
      </Card.Description>
    </Card.Content>
  </Card>
)

const AbilityCard = ({type, ability, color, src}) => (
  <Card fluid className={`guardian-ability-card ${color}`}>
    <Card.Content>
      <div className='guardian-ability-icon-container'>
        <Image
          floated='left'
          size='tiny'
          src={src}
        />
      </div>
      <Card.Header>{ability?.name}</Card.Header>
      <Card.Meta>{type}</Card.Meta>
      <Card.Description>
        {ability?.text}
      </Card.Description>
    </Card.Content>
  </Card>
)

const DirectionPanel = ({role, faction, onHandleBack, onHandlePrevious, onHandleNext}) => (
  <Card className={`guardian-direction-panel bcg-${colorForRole(role)}-secondary`}>
    <Grid>
      <Grid.Row columns={3}>
        <Grid.Column width={3}> 
          <Icon style={{float: 'left', cursor: 'pointer'}} size='big' name='arrow left' onClick={onHandlePrevious} />
        </Grid.Column>        
        <Grid.Column width={10} style={{textAlign: 'center'}}>
          <GuardianAlternateRoleIcon role={role} size='xx-small' />
          <Label className='transparent' style={{cursor: 'pointer', color: 'white', margin: 'auto 0.75em'}} onClick={onHandleBack}>Back To Cards</Label>
          <GuardianFactionIcon faction={faction} size='xx-small' />
        </Grid.Column>
        <Grid.Column width={3}>
          <Icon style={{float: 'right', cursor: 'pointer'}} size='big' name='arrow right' onClick={onHandleNext} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Card>
)

export const GuardianCards = ({visible = true, centered = false, onHide, guardians, itemsPerRow, onClick}) => (
  <Transition
          animation='fade'
          reactKey='guardian-cards'
          transitionOnMount={true}
          unmountOnHide={true}
          visible={visible}
          onHide={onHide}
          duration={500}
          >

          <section className='guardian-cards-container'>
                <Card.Group centered={centered} itemsPerRow={itemsPerRow}>
                  {guardians.map((guardian, index) => 
                    <GuardianCard key={guardian?.id} 
                                        guardian={guardian} 
                                        size={'medium'}  //itemsPerRow > 1 ? 'medium' : 'small'
                                        onClick={(e) => {onClick(index)}}
                            />
                  )}
                </Card.Group>
              </section>
    </Transition>
)

export default class Guardians extends Component {
    state = {
        itemsPerRow: 5,
        cardsVisible: false,
        detailsVisible: false,
        selectedIndex: -1,
        selectedGuardian: null,
        isLandscape: true
    }

    updateDimensions() {
      let count = 3
      if (window.innerWidth >= 1200) {
        count = 5
      } else if (window.innerWidth < 1200 && window.innerWidth > 830) {
        count = 4
      } else if (window.innerWidth <= 830 /*&& window.innerWidth > 640*/) {
        count = 3
      }
      //  else if (window.innerWidth <= 640 && window.innerWidth > 500) {
      //   count = 2
      // }

      this.setState({itemsPerRow: count, isLandscape: window.innerWidth > window.innerHeight})
    }

    checkLoad = (params) => {
      const {id} = params

      if (id) {
        const index = guardianIds.findIndex((item) => {return item.id?.toLowerCase() === id})
        this.handleCardClick(index)

        window.history.replaceState(null, null, "/guardians")
      } else {
        this.setState({cardsVisible: true})
      }
    }

    componentDidMount() {
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));

      this.checkLoad(this.props.match.params)
    }
  
    /**
     * Remove event listener
     */
    componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
  
    handleBackToCards = () => {
      this.setState({detailsVisible: false, selectedGuardian: null})
    }

    handleCardClick = async (index) => {
      if (index < 0) {
        index = guardianIds.length-1
      } 
      if (index >= guardianIds.length) {
        index = 0
      }

      let guardian = guardianIds[index]

      if (guardian === undefined || isObjectEmpty(guardian)) {
        return
      }
      let selectedGuardian = cachedGuardians[guardian?.id]
      if (selectedGuardian === null || selectedGuardian === undefined) {
        selectedGuardian = await getGuardian(guardian?.id)
        cachedGuardians[guardian?.id] = selectedGuardian
      } 

      const {cardsVisible} = this.state
      if (cardsVisible) {
        this.setState({cardsVisible: false, selectedGuardian, selectedIndex: index})
      } else {
        this.setState({detailsVisible: true, selectedGuardian, selectedIndex: index})
      }
    }

    handlePrevious = () => {
      const {selectedIndex} = this.state
      this.handleCardClick(selectedIndex-1)
    }

    handleNext = () => {
      const {selectedIndex} = this.state
      this.handleCardClick(selectedIndex+1)
    }

    render() {
        const {isLandscape, itemsPerRow, cardsVisible, detailsVisible, selectedGuardian} = this.state
        return (
            <Container fluid={detailsVisible}>
              <Transition 
              animation='fade'
              reactKey='guardian-details'
              transitionOnMount={true}
              unmountOnHide={true}
              visible={detailsVisible}
              onHide={() => {this.setState({cardsVisible: true})}}
              duration={500}
              >
              <section className='guardian-details-container'>
                {selectedGuardian ? (
                  <GuardianDetailsPage 
                    landscapeView={isLandscape}
                    guardian={selectedGuardian}
                    onHandleBack={this.handleBackToCards.bind(this)}
                    onHandlePrevious={this.handlePrevious.bind(this)}
                    onHandleNext={this.handleNext.bind(this)}
                  />
                ) : null }
              </section>
              </Transition>

              
                <GuardianCards visible={cardsVisible}
                                onHide={() => {this.setState({detailsVisible: true})}}
                                itemsPerRow={itemsPerRow}
                                guardians={guardianIds}
                                onClick={this.handleCardClick.bind(this)}
                              />
              
            </Container>
        )
    }
}